import { Navbar } from '../../components/Navbar';
import { useTranslation } from 'react-i18next';

import HomePageBG from '../../assets/HomepageBG.jpg';
import { ContentBox } from '../../components/ContentBox';

import { PictureContentLeft } from '../../components/PictureContentLeft';

import SliProcessContentEN from '../../assets/SLI_process.svg';
import SliProcessContentES from '../../assets/SLI_process-Spanish.svg';
import { ExternalLinkButton } from '../../components/ExternalLinkButton';

const HomePage = () => {
  const { t, i18n } = useTranslation();

  const sliProcessImages = {
    en: SliProcessContentEN,
    es: SliProcessContentES,
  };

  const sliProcessImage = sliProcessImages[i18n.language] || sliProcessImages.en;

  return (
    <div>
      <Navbar
        src={HomePageBG}
        pageName={t('homePage.navbar.pageName')}
        pageText={t('homePage.navbar.pageText')}
      />
      <ContentBox
        title={t('homePage.contentBox.title')}
        content={
          <div>
            {t('homePage.contentBox.intro')}
            {'('}
            <strong>SLI</strong>
            {')'}
            {t('homePage.contentBox.introEnd')}
            <p>&nbsp;</p>
            {t('homePage.contentBox.includesLabel')}
            <ul class="indent-3 list-inside">
              <li style={{ listStyleType: 'square' }}>
                {t('homePage.contentBox.listItems.farmAnalysis')}
              </li>
              <li style={{ listStyleType: 'square' }}>
                {t('homePage.contentBox.listItems.consultationPart1')}
                <strong>{t('homePage.contentBox.listItems.consultationBoldWord')}</strong>
                {t('homePage.contentBox.listItems.consultationPart2')}
              </li>
              <li style={{ listStyleType: 'square' }}>
                {t('homePage.contentBox.listItems.fundingAssistance')}
              </li>
              <li style={{ listStyleType: 'square' }}>
                {t('homePage.contentBox.listItems.training')}
              </li>
              <li style={{ listStyleType: 'square' }}>
                {t('homePage.contentBox.listItems.electrification')}
              </li>
              <li style={{ listStyleType: 'square' }}>
                {t('homePage.contentBox.listItems.marketAccess')}
              </li>
            </ul>
            <div className="py-5 px-10 md:px-0 flex items-center align-center justify-center md:align-start md:items-start md:justify-start mx-auto">
              <ExternalLinkButton
                href="https://usltrcd-prod-mobile.f2-cloud.com/SelfService/submission/submit/Intake_form"
                target="_blank"
              >
                {t('homePage.contentBox.button')}
              </ExternalLinkButton>
            </div>
          </div>
        }
        bgColor={'#CFE3F6'}
        titleColor={'#2E7A32'}
        textAlign={'text-left'}
      />
      <PictureContentLeft
        title={t('homePage.howItWorks.title')}
        titleColor="#2E7A32"
        content={
          <div>
            <ul>
              <li className="mb-3" style={{ listStyleType: 'square' }}>
                <strong>{t('homePage.howItWorks.steps.intakeForm.label')}</strong>{' '}
                {t('homePage.howItWorks.steps.intakeForm.description')}
              </li>
              <li className="mb-3" style={{ listStyleType: 'square' }}>
                <strong>{t('homePage.howItWorks.steps.siteAssessment.label')}</strong>{' '}
                {t('homePage.howItWorks.steps.siteAssessment.description')}
              </li>
              <li className="mb-3" style={{ listStyleType: 'square' }}>
                <strong>{t('homePage.howItWorks.steps.planDesign.label')}</strong>{' '}
                {t('homePage.howItWorks.steps.planDesign.description')}
              </li>
              <li className="mb-3" style={{ listStyleType: 'square' }}>
                <strong>{t('homePage.howItWorks.steps.consultPrioritize.label')}</strong>{' '}
                {t('homePage.howItWorks.steps.consultPrioritize.description')}
              </li>
              <li className="mb-3" style={{ listStyleType: 'square' }}>
                <strong>{t('homePage.howItWorks.steps.selectFunding.label')}</strong>{' '}
                {t('homePage.howItWorks.steps.selectFunding.description')}
              </li>
              <li className="mb-3" style={{ listStyleType: 'square' }}>
                <strong>{t('homePage.howItWorks.steps.implementation.label')}</strong>{' '}
                {t('homePage.howItWorks.steps.implementation.description')}
              </li>
              <li className="mb-3" style={{ listStyleType: 'square' }}>
                <strong>{t('homePage.howItWorks.steps.monitoring.label')}</strong>{' '}
                {t('homePage.howItWorks.steps.monitoring.description')}
              </li>
              <li className="mb-3" style={{ listStyleType: 'square' }}>
                <strong>{t('homePage.howItWorks.steps.marketConnections.label')}</strong>{' '}
                {t('homePage.howItWorks.steps.marketConnections.description')}
              </li>
            </ul>
            <div className="pt-5 px-5 md:px-0 flex items-center text-center align-center justify-center md:align-start md:items-start md:justify-start">
              <ExternalLinkButton
                href="https://usltrcd-prod-mobile.f2-cloud.com/SelfService/submission/submit/Intake_form"
                target="_blank"
              >
                {t('homePage.howItWorks.button')}
              </ExternalLinkButton>
            </div>
          </div>
        }
        srcImg={sliProcessImage}
        // btnContent={

        // }
        // btnColor="#A8C356"
        display="inline-block"
      />
    </div>
  );
};

export { HomePage };
